import { Grade, GradeConfig, IGradeApiCall, IRestApiService } from '../types';
import { GradeTracker } from '../services/analytics/apiTrackers/gradeTracking';

class GradeApiCall implements IGradeApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getGrade(studioClientId: string, attendanceId: string): Promise<Grade[]> {
    return this.restApiService.get(`grade/${studioClientId}/${attendanceId}`);
  }

  updateGrades(studioClientId: string, attendanceId: string, grades: Grade[]): Promise<void> {
    const startTime = Date.now();

    return this.restApiService
      .patch(`grade/studioClientId/${studioClientId}/attendanceId/${attendanceId}`, { grades })
      .then((result) => {
        GradeTracker.trackUpdateGrades({
          studioClientId,
          attendanceId,
          grades,
          success: true,
          duration: Date.now() - startTime,
        });
        return result;
      })
      .catch((error) => {
        GradeTracker.trackUpdateGrades({
          studioClientId,
          attendanceId,
          grades,
          success: false,
          error: error.message || error,
          duration: Date.now() - startTime,
        });
        throw error;
      });
  }

  addGrades(studioClientId: string, attendanceId: string, grades: Grade[]): Promise<void> {
    const startTime = Date.now();

    return this.restApiService
      .post(`grade/studioClientId/${studioClientId}/attendanceId/${attendanceId}`, { grades })
      .then((result) => {
        GradeTracker.trackAddGrades({
          studioClientId,
          attendanceId,
          grades,
          success: true,
          duration: Date.now() - startTime,
        });
        return result;
      })
      .catch((error) => {
        GradeTracker.trackAddGrades({
          studioClientId,
          attendanceId,
          grades,
          success: false,
          error: error.message || error,
          duration: Date.now() - startTime,
        });
        throw error;
      });
  }
  getGradeConfig(ownerId: string): Promise<GradeConfig> {
    return this.restApiService.get(`grade/config/owner/${ownerId}`);
  }

  addGradeConfig(ownerId: string): Promise<GradeConfig> {
    const startTime = Date.now();

    return this.restApiService
      .post(`grade/config/owner/${ownerId}`)
      .then((result) => {
        GradeTracker.trackAddGradeConfig({
          ownerId,
          success: true,
          duration: Date.now() - startTime,
        });
        return result;
      })
      .catch((error) => {
        GradeTracker.trackAddGradeConfig({
          ownerId,
          success: false,
          error: error.message || error,
          duration: Date.now() - startTime,
        });
        throw error;
      });
  }
}

export default GradeApiCall;
